import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as apiClient from "../../common/apiClient";
import {
  Container, BoxContainer, Box1, ImageBox, CircleBox, CustomerCareImge, CircleItem, CircleImg, FormContainer, FieldContainer, FieldLabel, Input, Fields, Header, InputTextArea,FieldTextAreaContainer,SubmitButton,ButtonSection
} from './styled';

import Chat_Icon from '../../assets/chaticon.svg';
import Customer_Care from '../../assets/customercare.svg';
import Email_Icon from '../../assets/email.svg';
import Cust_Icon from '../../assets/cust.svg';


import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ReportViewer from '../ui/reportViewer/reportviewer';
import * as App_Constant from "../../common/constants";
import {

  Spinner,
  SpinnerSize,

} from '../../components';
export const CustomerCare = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <BoxContainer>
        <Box1>
          <CircleBox>
            <CircleItem>Chat with Us</CircleItem>
            <CircleImg src={Chat_Icon} />
          </CircleBox>
          <CircleBox>
            <CircleItem>Write Email</CircleItem>
            <CircleImg src={Email_Icon} />
          </CircleBox>
          <CircleBox>
            <CircleItem>Customer Care</CircleItem>
            <CircleImg src={Cust_Icon} />
          </CircleBox>
        </Box1>
        <ImageBox>
          <CustomerCareImge src={Customer_Care} />
        </ImageBox>
      </BoxContainer>
      <Header>Write Us</Header>
      <FormContainer>
      <Fields>
        <FieldContainer> 
          <Input placeholder='Name' /> 
        </FieldContainer>
        <FieldContainer> 
          <Input placeholder='Email' /> 
        </FieldContainer>
        <FieldContainer> 
          <Input placeholder='Phone' /> 
        </FieldContainer>
        <FieldContainer> 
          <Input placeholder='Organzation' />
          {/* value={customerFirstName} onChange={(e) => setCustomerFirstName(e.target.value)} disabled={requestId != null} /> */}
        </FieldContainer>

        <FieldTextAreaContainer> 
          <InputTextArea placeholder='Write your message' />
          {/* value={customerFirstName} onChange={(e) => setCustomerFirstName(e.target.value)} disabled={requestId != null} /> */}
        </FieldTextAreaContainer> 
        
        <ButtonSection>
        <SubmitButton>Submit</SubmitButton> 
        </ButtonSection>    
      </Fields>
      
      </FormContainer>
    </Container>
  );
};
